import SwapVertIcon from "@mui/icons-material/SwapVert";

type CustomSwapVertProps = {
    onClick: Function;
    rotate: boolean;
    customheight?: string;
};

export default function CustomSwapVert({
    onClick,
    rotate,
    customheight,
}: CustomSwapVertProps) {
    return (
        <SwapVertIcon
            onClick={() => {
                onClick();
            }}
            sx={{
                transform: `rotate(${rotate ? -360 : 360}deg)`,
                transition: "transform 0.2s ease",
                cursor: "pointer",
                width: "40px",
                height: customheight ?? "30px",
            }}
        />
    );
}
